<common-mojo-expandable-card
  [expandable]="expandable"
  (toggle)="toggleCard($event)"
  *ngIf="showCard; else talentPoolView"
>
  <ng-template-outlet *ngTemplateOutlet="cetificationsContent">
  </ng-template-outlet>
</common-mojo-expandable-card>

<ng-template #talentPoolView>
  <mojo-expandible-card
    [expandable]="expandable"
    (toggle)="toggleCard($event)"
  >
    <ng-template-outlet *ngTemplateOutlet="cetificationsContent">
    </ng-template-outlet>
  </mojo-expandible-card>
</ng-template>

<ng-template #cetificationsContent>
  <div
    class="certifications-header"
    [ngClass]="{'font-size-talent-pool': !showCard}"
  >Certifications</div>
  <div class="certification-list-wrapper">
    <div
      *ngFor="let certificate of displayedCertifications; trackBy: track"
      class="certificate-item"
      [ngClass]="{'font-size-talent-pool': !showCard}"
    >
      <div class="certificate-name">{{ certificate?.name}}</div>

      <div class="certificate-description">{{ certificate?.description}}</div>

      <div
        *ngIf="!!certificate?.firstIssuedDate"
        class="certificate-date"
      >
        {{ certificate?.firstIssuedDate | daysPassed: true }}
      </div>
    </div>
  </div>
</ng-template>
